import styled from 'styled-components'

import { Link } from 'react-router-dom'

interface IStyledLink {
  disabled?: boolean;
  noUnderline?: boolean;
}

export const StyledLink = styled(Link) <IStyledLink>`
  text-decoration: underline;

  ${(props) => (props.noUnderline) && `
    text-decoration: none;
 `}

 ${(props) => (props.disabled) && `
    cursor: default;
 `}
`
